import React from "react";

interface DatePropertyFieldProps {
  value: any;
  onChange: (value: any) => void;
  placeholder?: string;
}

export default function DatePropertyField({ value, onChange, placeholder }: DatePropertyFieldProps) {
  // Helper to get string value
  const dateStr = value && typeof value === 'object' && value.value !== undefined ? value.value : (value || '');

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newVal = e.target.value;
    if (!newVal) {
      onChange({ value: '', timestamp: 0 });
      return;
    }
    
    // Convert to timestamp
    const dateObj = new Date(newVal);
    const timestamp = dateObj.getTime();
    
    onChange({ value: newVal, timestamp });
  };

  return (
    <div className="flex flex-col space-y-1">
      <input
        type="datetime-local"
        value={dateStr}
        onChange={handleChange}
        placeholder={placeholder}
        className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent text-xs bg-white"
      />
      {value && typeof value === 'object' && value.timestamp ? (
        <span className="text-[10px] text-gray-400">Timestamp: {value.timestamp}</span>
      ) : null}
    </div>
  );
}
